export namespace Bancos {
	export enum RATING_ITAU {
		BA2 = 'BA2',
		B2 = 'B2',
		B3 = 'B3',
		C1 = 'C1',
		C3 = 'C3'
	}

	export enum RATING_BRADESCO {
		APTO = 'A',
		NAO_APTO = 'N'
	}

	export enum RATING_SANTANDER {
		APTO = 'A',
		NAO_APTO = 'N'
	}
}
